import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  boardScrollbar: {
    overflow: 'auto',
    paddingBottom: theme.spacing(2),
  },
  boardHeader: {
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    padding: theme.spacing(2),
    textAlign: 'center',
    minHeight: 'fit-content',
    color: theme.palette.common.white,
    width: 440,
    [theme.breakpoints.down('xs')]: {
      width: 350,
    },
  },
  boardContent: {
    flex: 1,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    paddingLeft: theme.spacing(2),
    paddingBlock: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.primary.main}`,
    overflow: 'hidden',
    width: 440,
    [theme.breakpoints.down('xs')]: {
      width: 350,
    },
  },
  scrollbar: {
    paddingRight: theme.spacing(2),
    height: '100%',
  },
  boardBody: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(1),
    width: '100%',
    alignItems: 'center',
  },
  notFoundQuestions: {
    width: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
}))

export default styles
